import { render, staticRenderFns } from "./ExpedienteDetailCardActionButton.vue?vue&type=template&id=d922a602&scoped=true&"
import script from "./ExpedienteDetailCardActionButton.vue?vue&type=script&lang=js&"
export * from "./ExpedienteDetailCardActionButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteDetailCardActionButton.vue?vue&type=style&index=0&id=d922a602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d922a602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VFlex,
  VLayout,
})
